const PropTypes = require('prop-types');
// @vendors
const React = require('react');
// @components
const ChatBarContainer = require('./bar/ChatBarContainer');
const ChatError = require('./error/ChatError');
const ChatMessagesContainer = require('./messages/ChatMessagesContainer');
const ChatSendMessageContainer = require('./sendMessage/ChatSendMessageContainer');
const ChatUnavailable = require('./error/ChatUnavailable');

// @constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE,
    }
} = require('constants/chat');


require('./ChatExpanded.scss');

const ChatExpanded = props => {
    const { conversationStatus, toggleWindow, chatAvailabilityStatusData } = props;
    const nextOpening = chatAvailabilityStatusData.get('nextOpening');
    let chatContent = [];

    if(nextOpening > 0) {
        chatContent.push(
            <ChatUnavailable chatAvailabilityStatusData={chatAvailabilityStatusData}/>
        );
    } else {
        chatContent.push(
            <ChatMessagesContainer />,
            <ChatSendMessageContainer
                conversationStatus={conversationStatus}
            />
        )
    }

    if (conversationStatus === ERROR) {
        chatContent = [<ChatError key={0} />];
    }
    return (
        <div className="chat__expanded">
            <ChatBarContainer toggleWindow={toggleWindow} />
            {chatContent}
        </div>
    );
};

ChatExpanded.propTypes = {
    chatAvailabilityStatusData: PropTypes.object.isRequired,
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    toggleWindow: PropTypes.func.isRequired
};

module.exports = ChatExpanded;
